
import {Deal, DealType} from "@irati/types"
import DealHighlightTypes from "@irati-web/perks/src/constants/dealHighlightTypes"
import isTimeLimited from "./isTimeLimited"

export function getTypeHighlight(deal: Deal) {
  if (isTimeLimited(deal)) {
    return DealHighlightTypes.TIME_LIMIT_24_HOUR
  }

  if(deal.type === DealType.Merchandise) {
    return DealHighlightTypes.MERCHANDISE
  }

  return deal.typeHighlight
}

export function getDeliveryHighlight(deal: Deal) {
  if(deal.type === DealType.Merchandise) {
    return DealHighlightTypes.SHIPPING_INCLUDED
  }

  return deal.deliveryHighlight
}
